export default "__VITE_ASSET__DwVdIB9W__"